import { render } from "./UsersManager.vue?vue&type=template&id=5c30efcd&scoped=true"
import script from "./UsersManager.vue?vue&type=script&lang=js"
export * from "./UsersManager.vue?vue&type=script&lang=js"

import "./UsersManager.vue?vue&type=style&index=0&id=5c30efcd&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c30efcd"]])

export default __exports__